export default __webpack_public_path__ + "static/media/cfo_comLogo.2776f772.svg";